import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from "react-router-dom";

// reactstrap components
import { Button, Card, CardBody, FormGroup, Form, Input, Row, Col, Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";

// views
import Documentos from "../../views/Shared/Documentos";

//Context
import { useAuth } from "../../context/auth";
import CardRejeicaoRequerimento from "./components/CardRejeicaoRequerimento";


export default function RequerimentoCancelamento({ history }) {
    const { session, setLoading, setupSistema } = useAuth();

    const { register, handleSubmit, setValue } = useForm({ mode: "onBlur" });
    const location = useLocation();

    const [requerimento, set_requerimento] = React.useState(null);

    const [opcao, set_opcao] = React.useState(Object);

    const [steps, set_steps] = React.useState(["Motivo", "Documentos"]);

    const loadSteps = async () => {
        setLoading(true);
        try {
            const { data } = await api_GET('setupSolicitacao/GetByAcaoId/' + location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id);

            set_opcao({
                tipoCadastro: "Requerimento",
                segmento: data.segmento,
                categoria: data.categoria
            });

            const acao = data.solicitacaoAcoes.find(
                f => f.setupSolicitacaoAcao_Id === location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id
            );

            if (acao && acao.acaoDocumentos.length > 0) {
                set_steps(["Motivo", "Documentos"]);
            } else {
                set_steps(["Motivo"]);
            }
        } catch (err) {
            showMessage("Aviso", err.message, 'error', null);
        } finally {
            setLoading(false);
        }
    };

    const [step, set_step] = React.useState(0);
    const handleProximoStep = (_requerimento) => {
        if (step <= 2) {
            set_requerimento(_requerimento);
            set_step(step + 1);
        }
    }
    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const loadRequerimento = async () => {
        try {
            setLoading(true);

            if (location.state.requerimento == null) {
                const json_submit = {
                    protocolo_Id: location.state.protocolo.protocolo_Id,
                    requerimento_Id: 0,
                    nomeSolicitante: location.state.protocolo.nomeSolicitante,
                    email: location.state.protocolo.email,
                    cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                    setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
                };

                const { data } = await api_POST('requerimento/PostRequerimento ', json_submit);
                set_requerimento(data);
            } else {
                const { data } = await api_GET('requerimento/' + location.state.requerimento.requerimento_Id);
                set_requerimento(data);

                if (data.requerimentoMotivoCancelamento.length > 0) {
                    setValue("motivo", data.requerimentoMotivoCancelamento[0].motivo);
                }
            }
        } catch (err) {
            showMessage("Aviso", err.message, 'error', null);
        } finally {
            setLoading(false);
        }
    };


    const handleFinalizarRequerimento = async () => {
        setLoading(true);
        try {
            await api_POST('requerimento/PostFinalizarSolicitacaoRequerimento', requerimento);
            showMessage(
                "Aviso",
                "Solicitação enviada com sucesso. Acompanhe o andamento através do seu cadastro!",
                'success',
                () => history.push("/auth/meucadastro")
            );
        } catch (err) {
            showMessage("Aviso", err.message, 'error', null);
        } finally {
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        if (data.motivo === "") {
            showMessage("Aviso", "Preencha a descrição do motivo do cancelamento!", 'error', null);
            return;
        }

        const json_submit = {
            requerimentoMotivoCancelamento_Id: requerimento.requerimentoMotivoCancelamento.length > 0
                ? requerimento.requerimentoMotivoCancelamento[0].requerimentoMotivoCancelamento_Id
                : 0,
            requerimento_Id: requerimento.requerimento_Id,
            motivo: data.motivo
        };

        setLoading(true);
        try {
            let result;
            if (json_submit.requerimentoMotivoCancelamento_Id === 0) {
                result = await api_POST('Requerimento/PostRequerimentoMotivoCancelamento', json_submit);
            } else {
                result = await api_PUT('Requerimento/PutRequerimentoMotivoCancelamento', json_submit);
            }

            if (steps.length > 1)
                handleProximoStep(result.data);
            else
                handleFinalizarRequerimento();
        } catch (err) {
            showMessage("Aviso", err.message, 'error', null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadSteps();
        loadRequerimento();
    }, []);

    return (
        <>
            {requerimento != null && (requerimento.status == "Em Andamento" || requerimento.status == "Divergente") &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    <CardRejeicaoRequerimento requerimento={requerimento} setupSistema={setupSistema} tituloClassName={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`} />
                    {step == 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <Form onSubmit={handleSubmit(onSubmit)}>
                                    <h2 className="titulo-solicitacao">Motivo do Cancelamento </h2>
                                    <Container style={{ maxWidth: "1000px", margin: "0px auto" }}>
                                        <Row>
                                            <Col md="12">
                                                <FormGroup>
                                                    <b><label>Descrição do Motivo do Cancelamento</label></b>
                                                    <Input type="textarea" name="motivo" innerRef={register()} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="12" className="text-right">
                                                <Button color="success" className="btn-mobile" type="submit">{steps.length > 1 ? "Próxima Etapa" : "Concluir"}  <i className="fas fa-chevron-right"></i></Button>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Form>
                            </CardBody>
                        </Card>
                    }
                    {step == 1 && <Documentos item={requerimento} opcao={opcao} handleProximoStep={handleFinalizarRequerimento} handleStepAnterior={handleStepAnterior}></Documentos>}
                </div>
            }
            {requerimento != null && (requerimento.status != "Em Andamento" && requerimento.status != "Divergente") &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}